import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getAppointmentProfiles = async (): Promise<AxiosResponse> =>
	await api.get('/candidates/appointment-profiles');
